<template>
  <Modal
    :value="visible"
    @on-cancel="cancelHandler"
    footer-hide
    title="复制节点"
    width="500px"
  >
    <Form :model="formData" ref="form" :label-width="110">
			<FormItem label="目标流程" >
        <Select v-model="formData.nodeId" placeholder="如果空，则复制到当前流程">
          <Option v-for="flow in flows" :key="flow.id" :value="flow.id">{{flow.name}}</Option>
        </Select>
      </FormItem>
      <div class="btn">
        <Button style="margin-right: 20px" color="#547ed1" @click="cancelHandler">取消</Button>
        <Button
          type="primary"
          style="margin-right: 20px"
          color="#547ed1"
          @click="submit"
        >
          确定
        </Button>
      </div>
    </Form>
  </Modal>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep'
import { addNodeId } from '@/utils/nodeIdPool';

export default {
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    copyData: {
      type: Object,
    }
  },
	computed: {
    ...mapState('flow', [
			'flows',
    ])
  },
  data() {
    return {
      formData: {
        nodeId: 0,
      },
    };
  },
  methods: {
    ...mapActions('flow', ['switchFlow']),
    submit() {
      if (this.formData.nodeId) {
        this.switchFlow(this.formData.nodeId)
      }
  
      const newNode = cloneDeep(this.copyData);
      // 清除不需要的输入
      newNode.id = undefined;
      newNode.outs = newNode.outs?.filter(out => out.intent_id !== '_miss')
        .map(out => ({ ...out, id: undefined, target_id: undefined }))
      // 修改录音id
      newNode.voices = newNode.voices?.map(voice => ({
        ...voice,
        id: addNodeId('V')
      }))
      this.$emit('addNode', newNode)
      this.cancelHandler();
    },
    cancelHandler() {
      this.resetFormData();
      this.$emit('change', false)
      this.$emit('cancel');
    },
    resetFormData() {
      this.$refs.form.resetFields()
      this.formData = {
        nodeId: 0,
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>